"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _cccisdLaravelReport = require("cccisd-laravel-report");
var _cccisdLaravelAppdefs = require("cccisd-laravel-appdefs");
var _widgets = _interopRequireDefault(require("../widgets.js"));
var _filterFields = _interopRequireDefault(require("../filterFields.js"));
var _ReportHeader = _interopRequireDefault(require("../../components/ReportHeader"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = function Component(props) {
  var _props$widgets = props.widgets,
    fidelitySGSummaryCallouts = _props$widgets.fidelitySGSummaryCallouts,
    fidelitySGOverallChart = _props$widgets.fidelitySGOverallChart,
    overallFidelityInfoTab = _props$widgets.overallFidelityInfoTab,
    fidelitySGAverageChart = _props$widgets.fidelitySGAverageChart,
    fidelitySGAdherenceChart = _props$widgets.fidelitySGAdherenceChart,
    componentsCallouts = _props$widgets.componentsCallouts,
    componentsInfoTab = _props$widgets.componentsInfoTab,
    fidelitySummaryTable = _props$widgets.fidelitySummaryTable,
    summaryTableInfoTab = _props$widgets.summaryTableInfoTab,
    fidelitySGFacilitatorChart = _props$widgets.fidelitySGFacilitatorChart,
    fidelitySGFacilitatorTable = _props$widgets.fidelitySGFacilitatorTable,
    fidelityAdherenceTable = _props$widgets.fidelityAdherenceTable,
    fidelityComments = _props$widgets.fidelityComments,
    recommendations = _props$widgets.recommendations;
  var heading = props.settings.body.heading;
  return /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Report, null, /*#__PURE__*/_react["default"].createElement(_cccisdLaravelReport.Page, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper
  }, /*#__PURE__*/_react["default"].createElement(_ReportHeader["default"], {
    settings: props.settings,
    filters: props.filters,
    isPreview: props.isPreview,
    data: props.data
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].reportBodyText
  }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
    content: heading
  })), fidelitySGSummaryCallouts, fidelitySGOverallChart, fidelitySGAverageChart, fidelitySummaryTable, overallFidelityInfoTab, fidelitySGFacilitatorChart, fidelitySGFacilitatorTable, summaryTableInfoTab, componentsCallouts, fidelitySGAdherenceChart, fidelityAdherenceTable, componentsInfoTab, fidelityComments, recommendations)));
};
Component.propTypes = {
  settings: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool,
  filters: _propTypes["default"].object,
  widgets: _propTypes["default"].object,
  data: _propTypes["default"].object
};
var _default = exports["default"] = (0, _cccisdLaravelAppdefs.reportTemplatePlayer)({
  reportHandle: 'outcomes',
  widgets: _widgets["default"],
  getFilterFields: function getFilterFields(props) {
    return _filterFields["default"].map(function (field) {
      return field.name === 'groupIds' ? _objectSpread(_objectSpread({}, field), {}, {
        initialValue: props.data.groups.treatmentGroupList.map(function (tg) {
          return tg.group.groupId;
        }).slice(0, 1)
      }) : field;
    });
  }
})(Component);